module.exports = __webpack_public_path__ + "static/img/speech_bubble.27c0247.png";